var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%","display":"flex"}},[_c('div',{staticClass:"framePage-scroll"},[_c('div',{staticClass:"ovy-a"},[_c('iframe',{staticStyle:{"width":"100%","height":"99%"},attrs:{"src":_vm.pdfUrl,"frameborder":"0"}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }